import { useTranslation } from 'react-i18next';
import { Header, LwBlockGridContainer, Page, Toolbox } from 'redesign';
import { RenderUnsettledUI } from 'shared/components/render-unsettled-ui/render-unsettled-ui';
import { Typography } from '@mui/material';
import { useGetServiceAgreements } from './hooks/use-get-service-agreements-listing';
import { ServiceAgreementBlock } from './components/service-agreement-block';

export const CollegialLending = () => {
  const { t } = useTranslation('ogp-screen-specific');
  const serviceAgreementsQuery = useGetServiceAgreements();

  if (serviceAgreementsQuery.status !== 'success') {
    return <RenderUnsettledUI data={serviceAgreementsQuery} />;
  }

  const { data } = serviceAgreementsQuery;

  return (
    <Page
      header={<Header titleText={t('collegial_lending_page.title')} />}
      toolbox={<Toolbox></Toolbox>}
    >
      {data.length === 0 ? (
        <Typography>{t('collegial_lending_page.no_service_agreements')}</Typography>
      ) : (
        <LwBlockGridContainer container spacing={4}>
          {data.map((item, index) => (
            <ServiceAgreementBlock key={index} serviceAgreement={item} />
          ))}
        </LwBlockGridContainer>
      )}
    </Page>
  );
};
